import $ from 'jquery'
import Backbone from 'backbone'
import SingleFormfieldDialog from 'scoreboard/components/single-formfield-dialog'
import DatasetTree from './rollup-tree'
import { urlRoot } from './rollup-tree'
import appDisplay from 'scoreboard/components/app-display'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import DependenciesPreventActionView from 'scoreboard/components/edit/dependencies-prevent-action-view'
const createjQueryErrorHandler = DependenciesPreventActionView.createjQueryErrorHandler
import i18n from 'scoreboard/components/i18n'
import unwrapModel from 'scoreboard/components/unwrap-model'
import template from './rollup-tree-editor-menu.hbs'

/**
 * When the gardener is in edit mode, this is the tooltip menu that will be
 * displayed allowing the user to perform edit actions against each dataset tree
 * node.
 */
var RollupTreeEditorMenu = Backbone.View.extend({

	tagName: 'ul',

	className: 'tree-menu',

	/**
	 * @param {DatasetTree} options.model The tree node that was clicked on
	 */
	initialize: function(options) {
		this.options = options || {}
	},

	events: {
		'click .add': 'add',
		'click .rename': 'rename',
		'click .delete': 'delete'
	},

	add: function() {
		var datasetTree = new DatasetTree({
			parentId: this.model.id
		})
		this.addOrEdit(datasetTree)
	},

	rename: function() {
		this.addOrEdit(this.model)
	},

	addOrEdit: function(datasetTree) {
		var key = datasetTree.isNew() ? 'common.create2' : 'common.edit2'
		var form = new SingleFormfieldDialog({
			model: datasetTree,
			heading: i18n.get(key, 'datasets.dataType.rollupTree.item'),
			fieldLabel: 'common.name',
			// A more specific event is required here because adding nodes is not
			// the same as adding new trees (#35504).  These nodes must not show
			// up as items in the select.
			eventDomainType: 'dataset-tree-node'
		})
		appDisplay.dialog(form)
		this.listenTo(form, 'done', () => this.trigger('done'))
	},

	'delete': function() {
		var confirmation = new DeleteConfirmation(unwrapModel(this.model))
		appDisplay.dialog(confirmation)
		confirmation.on('confirm', function() {
			$.ajax({
				url: urlRoot + '/' + this.model.id,
				type: 'DELETE',
				success: () => {
					confirmation.trigger('done')
					Backbone.trigger('delete:domain-object', this.model)
					this.trigger('delete', this.model.id)
				},
				error: (response) => {
					let model = {label: this.model.get('treeLabel')}
					const title = i18n.get('common.error.cannotDelete', 'datasets.dataType.rollupTree')
					createjQueryErrorHandler({ model, title })(response)
				}
			})
		}.bind(this))
	},

	render: function() {
		this.$el.empty().append(template())
		return this
	}

})

export default RollupTreeEditorMenu

RollupTreeEditorMenu.__filename__ = 'admin/datasets/rollup-tree-editor-menu.js'
